import styled from 'styled-components';
import { spacing } from '@comicrelief/component-library';

const Wrapper = styled.div`
  margin: calc(${spacing('l')} + ${spacing('md')}) auto 0;
  padding: ${spacing('l')};
  width: calc(100% - ${spacing('xl')});
  background: ${({ theme }) => theme.color('white')};
  border-radius: 1rem;

  span:first-of-type {
    display: block;
    margin-bottom: ${spacing('md')};
  }

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    span:first-of-type {
     margin: 0 ${spacing('md')} 0 0;
    }

    span:first-of-type, select {
      display: inline-block;
      width: auto;
    }
  }

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    width: 50%;

    label {
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
    }
  }
`;

export default Wrapper;
